/**
 * Retourne un *string* de la forme "DD/MM/YYYY" en FR à partir d'une date.
 * @param date
 * @param locale
 */
export const getLocaleDateString = (date: Date, locale: string = 'fr-FR') => {
	return date.toLocaleDateString(locale);
};


/**
 * Retourne un *string* de la forme "2019-03-20T11:24:06.065Z".
 * @param date
 */
export const getDateTimeString = (date: Date) => {
	return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
};


/**
 * Retourne un *string* de la forme "lundi 1 janvier 2000" en FR à partir d'une date.
 * @param date
 * @param locale
 */
export const getElegantDateString = (date: Date, locale: string = 'fr-FR') => {
	return date.toLocaleDateString(locale, {
		weekday: "long",
		year: "numeric",
		month: "short",
		day: "numeric"
	});
};

/**
 * Retourne un *string* de la forme "2019-03-20".
 * @param date
 */
export const getDateString = (date: Date) => {
	return getDateTimeString(date).split("T")[0];
};
/**
 * Retourne un *string* de la forme "2019-03".
 * @param date
 */
export const getYearMonthString = (date: Date) => {
	const dateStringSplit = getDateString(date).split("-");
	return `${dateStringSplit[0]}-${dateStringSplit[1]}`;
};
/**
 * Retourne un *string* de la forme "11:24:06.065Z".
 * @param date
 */
export const getTimeString = (date: Date) => {
	return getDateTimeString(date).split("T")[1];
};
/**
 * Retourne un *string* de la forme "11:24".
 * @param date
 */
export const getShortTimeString = (date: Date) => {
	const timeSplit = getTimeString(date).split(":");
	return `${timeSplit[0]}:${timeSplit[1]}`;
};

/**
 * Ajout un nombre de minutes à un time de la forme "11:24".
 * @param time
 * @param nbMinutesToAdd
 */
export const addMinutes = (time: string, nbMinutesToAdd: number) => {
	const timeSplit = time.split(":");
	const hour = parseInt(timeSplit[0], 10);
	const minute = parseInt(timeSplit[1], 10);

	const rawMinuteAfterAddition = minute + nbMinutesToAdd;
	return `${(hour + Math.floor(rawMinuteAfterAddition / 60)).toString().padStart(2, '0')}:${(rawMinuteAfterAddition % 60).toString().padStart(2, '0')}`;
};

/**
 * Retourne un affichage *string* intelligent d'une durée en heures ou en minutes.
 * @param date
 */
export const smartDisplayMinutes = (minutes: number) => {
	if (minutes == null) {
		return '-';
	}
	if (minutes >= 60) {
		const remainingSeconds = minutes % 60;
		return `${Math.floor(minutes / 60)}h` + (remainingSeconds > 0 ? remainingSeconds.toString().padStart(2, '0') : '');
	}
	return `${minutes} min`;
};

/**
 * Retourne la différence en minutes entre *date1* et *date2* telles que date1 < date2.
 */
export const differenceInMinutesBetweenDates = (date1: Date, date2: Date) => {
	return Math.round(((date2.getTime() - date1.getTime()) / 1000) / 60); // minutes
};

/**
 * Retourne la différence en minutes entre *hh1:mm1* et *hh2:mm2* telles que hh1:mm1 < hh2:mm2.
 */
export const differenceInMinutesBetweenHoursMinutes = (hm1: string, hm2: string) => {
	const h1 = parseInt(hm1.split(':')[0], 10);
	const m1 = parseInt(hm1.split(':')[1], 10);
	const h2 = parseInt(hm2.split(':')[0], 10);
	const m2 = parseInt(hm2.split(':')[1], 10);
	return (60 * h2 + m2) - (60 * h1 + m1);
};

/**
 * Fonction de tri par date croissant si a < b.
 * @param a
 * @param b
 */
export const sortByDate = (a: Date, b: Date) => {
	return a > b ? -1 : a < b ? 1 : 0;
};


/**
 * Retourne la date minimale d'un array de dates.
 */
export const getMinDate = (dates: Date[]) => {
	return dates.reduce(function (a, b) { return a < b ? a : b; });
};

/**
 * Retourne la date maximale d'un array de dates.
 */
export const getMaxDate = (dates: Date[]) => {
	return dates.reduce(function (a, b) { return a > b ? a : b; });
};